import { Image, Text, VStack } from "@chakra-ui/react";
import React from "react";

export const Corporations = () => {
  return (
    <VStack
      w={['100%', '100%', "80%"]}
      px={10}
      h={['auto','auto',"100vh"]}
      py={['20px','20px',"80px"]}
      mt="60px"
      justifyContent="center"
      alignItems="center"
      id="corporations"
    >
       <Text
        bgColor="primary.700"
        size="xs"
        color="white"
        rounded='md'
        fontSize="small"
        fontWeight='semibold'
        py={2}
        px={4}
        userSelect='none'
        mb='20px'
      >
        Empresas
      </Text>
      <Text lineHeight="unset" fontSize={['24px','24px',"32px"]} color='#fff'>
        ¡Descubre la experiencia exclusiva de <strong>ViajáYa Empresas</strong>!
      </Text>
      <Text
        fontSize="md"
        lineHeight="unset"
        w="100%"
        textAlign={['left','left',"center"]}
        color="primary.400"
        mt={['10px','10px',"20px"]}
      >
        Conectá a tus colaboradores con la app, pagá con tu cuenta empresa y
        recibí el detalle de los recorridos. Pensado especialmente para
        empresas, nuestro servicio incluye características diseñadas para
        minimizar tiempos de espera y maximizar tu comodidad.
      </Text>
      <Image src="/leftCar.png" position="absolute" left={0} display={["none", "none", "block"]}/>
    </VStack>
  );
};
